export default __webpack_public_path__ + "static/media/celo-chain-logo.5d65811d.png";